import {
  ChangeDetectionStrategy,
  Component,
  Input,
  Output,
  OnInit,
  EventEmitter,
  OnChanges,
  SimpleChanges
} from '@angular/core';

import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { VirtualGridColumn } from '../../types';
import { TabsMode, Orientation, HorizontalAlignment, VerticalAlignment } from '@wfm/core';
import { VirtualGridWorklist } from '../../types/virtual-grid-worklist';
import { VirtualGridTemplate } from '../../types/virtual-grid-template';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'virtual-grid-layout',
  templateUrl: './virtual-grid-layout.component.html',
  styleUrls: ['./virtual-grid-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VirtualGridLayoutComponent implements OnInit, OnChanges {
  @Input() worklistColumnMetaData: Array<VirtualGridColumn> = [];
  @Input() managementWorklists: Array<VirtualGridWorklist> = [];
  @Input() templates: Array<VirtualGridTemplate> = [];

  @Input() selectedTemplate: VirtualGridTemplate;

  @Input() admin: boolean;

  @Input() activeTab: 'templates' | 'management' = 'templates';
  @Output() activeTabChange = new EventEmitter<string>();

  // Select a different Template OP : template
  @Output() selectedTemplateChange = new EventEmitter<VirtualGridTemplate>();

  // Apply a template to one or more  worklists  OP: worklistList and TemplateId
  @Output() applyTemplateToWorklistsEvent = new EventEmitter<Array<number>>();
  @Output() applyDefaultTemplateToWorklistsEvent = new EventEmitter<Array<number>>();
  @Output() revertToDefaultTemplateEvent = new EventEmitter<any>();

  // save a new Template from existing  OP: VirtualGridColumns
  @Output() createNewTemplateEvent = new EventEmitter<Array<VirtualGridColumn>>();
  @Output() applyWithoutSaveAndClose = new EventEmitter<Array<VirtualGridColumn>>();
  @Output() worklistColumnMetaDataChange = new EventEmitter<Array<VirtualGridColumn>>();

  @Output() worklistMetaSave = new EventEmitter<{ vgc: Array<VirtualGridColumn>; vgt: VirtualGridTemplate }>();

  private tempWorklistColumnMetaData: Array<VirtualGridColumn>;

  commontemplates: Array<VirtualGridTemplate> = [];
  alltemplates: Array<VirtualGridTemplate> = [];

  searchStr: string;
  masterSelected: boolean;
  systemSelected: boolean;
  customSelected: boolean;
  anySelected: boolean;
  applyToSystem: boolean;
  isCommonManagement: boolean;
  isCommonTemplate = true;
  systemTemplateSelected: boolean;
  checkedWorklists: Array<VirtualGridWorklist> = [];
  isLayoutChanged = false;
  isTemplateGlobalPrivate = false;

  templatesHashMap = new Map();

  tabSelected: number;
  tabsMode: TabsMode = TabsMode.modern;
  tabsO: Orientation = Orientation.horizontal;
  tabsHA: HorizontalAlignment = HorizontalAlignment.left;
  tabsVA: VerticalAlignment = VerticalAlignment.top;

  vposition = 0;
  itemSize = 40;

  renameSelected = false;
  saveAsSelected = false;
  saveAsName: string;

  shownWorklistColumnData: Array<VirtualGridColumn>;
  hiddenWorklistColumnData: Array<VirtualGridColumn>;

  isNewLayoutSaved = false;
  totalColumns;
  minColumnsShown = 2;
  maxColumnsShown = 25;

  disableRemove = false;
  layoutErrorMessage = '';
  maxUserLayouts = 10;
  maxGlobalLayouts = 25;

  selectedGlobalHasPrivate: boolean;
  autoSavedGlobalTemplate: VirtualGridTemplate;

  currentUserLayoutsCount = 0;
  globalLayoutsCount = 0;

  templateType = '';
  templateTypeList;

  filterBy: string = this.translate.instant('label.filterBy');

  templateTypeListAll = [
    {
      name: this.translate.instant('vgl.templates_commonRadio'),
      value: 'Common'
    },
    {
      name: this.translate.instant('vgl.templates_privateRadio'),
      value: 'Private'
    }
  ];

  templateTypeListPrivate = [
    {
      name: this.translate.instant('vgl.templates_privateRadio'),
      value: 'Private'
    }
  ];

  templateTypeListCommon = [
    {
      name: this.translate.instant('vgl.templates_commonRadio'),
      value: 'Common'
    }
  ];

  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.tabSelected = +(this.activeTab === 'management');
    this.isCommonTemplate = false;
    this.systemSelected = false;
    this.customSelected = false;

    // UX for Management WOrklists
    this.masterSelected = false;
    this.anySelected = false;
    this.checkUncheckAll();

    this.applyToSystem = false;
    this.isCommonManagement = true;
    this.systemTemplateSelected = false;
    this.disableRemove = false;

    this.tempWorklistColumnMetaData = [];
    if (this.worklistColumnMetaData) {
      for (let i = 0; i < this.worklistColumnMetaData.length; i++) {
        this.tempWorklistColumnMetaData.push({ ...this.worklistColumnMetaData[i] });
      }
    }
    this.totalColumns = this.tempWorklistColumnMetaData.length;
    if (this.maxColumnsShown > this.totalColumns) {
      this.maxColumnsShown = this.totalColumns - 1;
    }
    this.sendLogToHost({ Action: 'Layout Management Open in Admin', Data: this.admin });

    // Reset  variable to knwo if selected template has privateCopyOfGlobal
    this.autoSavedGlobalTemplate = null;
    this.templateType = '';

    // Add Massage Templates
    this.updateTemplateLists();
    // make sure Only are common are shown in Admin
    if (this.admin) {
      // in Admin mode select the first template
      this.selectedTemplate = this.commontemplates[0];
    }

    if (this.selectedTemplate) {
      this.selectedTemplateChange.emit(this.selectedTemplate);
      this.selectAndRenderRightTemplate();
    }
    this.isLayoutChanged = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.activeTab) {
      this.tabSelected = +(this.activeTab === 'management');
    }

    for (const propName in changes) {
      const changedProp = changes[propName];
      const to = changedProp.currentValue; //JSON.stringify(changedProp.currentValue);
      if (changedProp.isFirstChange()) {
      } else {
        if (propName === 'templates') {
          this.templates = to;
          this.updateTemplateLists();
          // gets the template from Hash Map to ensure we have the updated Ids after save
          const tempname = this.selectedTemplate.templateName;
          this.selectedTemplate = this.templatesHashMap.get(tempname);

          this.templateSelectionChange();
        }
        if (propName === 'managementWorklists') {
          this.sendLogToHost({ Action: 'Management Layouts applied ' });
          this.managementWorklists = to;
        }
      }
    }
  }

  private sortHidden() {
    this.hiddenWorklistColumnData = this.hiddenWorklistColumnData.sort((a, b) =>
      a.headerLabel > b.headerLabel ? 1 : -1
    );
  }

  drag(event: CdkDragDrop<string[]>) {
    const containerData =
      (event.container.id === 'shownDropList' && this.shownWorklistColumnData) || this.hiddenWorklistColumnData;
    const previousContainerData =
      (event.previousContainer.id === 'shownDropList' && this.shownWorklistColumnData) || this.hiddenWorklistColumnData;

    const previousIndex = previousContainerData.indexOf(event.previousContainer.data[event.previousIndex] as any);

    if (event.previousContainer === event.container) {
      moveItemInArray(containerData, previousIndex, event.currentIndex);
    } else {
      transferArrayItem(previousContainerData, containerData, previousIndex, event.currentIndex);
    }
    this.isLayoutChanged = true;

    // Sort Hidden and update Display when dropped on Hidden
    this.sortHidden();
    this.shownWorklistColumnData = [...this.shownWorklistColumnData];
    this.hiddenWorklistColumnData = [...this.hiddenWorklistColumnData];

    this.shownWorklistColumnData.forEach(column => {
      column.isHidden = false;
    });
    this.hiddenWorklistColumnData.forEach(column => {
      column.isHidden = true;
    });
  }

  dropShown(event: CdkDragDrop<string[]>) {
    if (!this.checkCanAddLayout()) {
      return;
    }
    this.drag(event);
  }

  /* Layout Management Events  */
  /*
  /* Drag and Drop event
  */
  drop(event: CdkDragDrop<string[]>) {
    if (!this.checkCanRemoveFromLayout()) {
      return;
    }
    this.drag(event);
  }

  checkCanAddLayout(): boolean {
    if (this.shownWorklistColumnData.length < this.maxColumnsShown) {
      this.layoutErrorMessage = '';
      return true;
    } else {
      this.layoutErrorMessage = this.translate
        .instant('vgl.templates_maxColumnsError')
        .replace('[maxColumns]', this.maxColumnsShown);
      return false;
    }
  }

  checkCanRemoveFromLayout(): boolean {
    if (this.shownWorklistColumnData.length > this.minColumnsShown) {
      this.layoutErrorMessage = '';
      return true;
    } else {
      this.layoutErrorMessage = this.translate
        .instant('vgl.templates_minColumnsError')
        .replace('[minColumns]', this.minColumnsShown);
      return false;
    }
  }

  addColumn(selectedColumn: VirtualGridColumn): void {
    const isAlreadyAdded = this.findInArray(this.shownWorklistColumnData, selectedColumn);
    if (isAlreadyAdded < 0) {
      if (this.checkCanAddLayout()) {
        selectedColumn.isHidden = false;
        const index = this.findInArray(this.hiddenWorklistColumnData, selectedColumn);
        this.shownWorklistColumnData.push(selectedColumn);
        this.hiddenWorklistColumnData.splice(index, 1);

        this.hiddenWorklistColumnData = [...this.hiddenWorklistColumnData];
        this.isLayoutChanged = true;
        this.sortHidden();
      }
    }
  }

  removeColumn(selectedColumn: VirtualGridColumn): void {
    if (this.checkCanRemoveFromLayout()) {
      selectedColumn.isHidden = true;
      const index = this.findInArray(this.shownWorklistColumnData, selectedColumn);
      this.disableRemove = false;
      this.hiddenWorklistColumnData.push(selectedColumn);
      this.hiddenWorklistColumnData = [...this.hiddenWorklistColumnData];
      this.shownWorklistColumnData.splice(index, 1);
      this.isLayoutChanged = true;
      this.sortHidden();
    } else {
      this.disableRemove = true;
    }
  }

  findInArray(arr, obj) {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].propertyIdentifier === obj.propertyIdentifier) {
        return i;
      }
    }
    return -1;
  }

  //  --------------- Outbound Events ---------------

  submit() {
    return;
  }
  done() {
    let all: Array<VirtualGridColumn> = [];
    all = all.concat(this.shownWorklistColumnData);
    all = all.concat(this.hiddenWorklistColumnData);
    this.applyWithoutSaveAndClose.emit(all);
  }

  saveColumns(): void {
    /* if user clicked "OK" save the changes in column metadata */
    if (this.renameSelected) {
      if (!this.checkDuplicateTemplateName()) {
        this.selectedTemplate.templateName = this.saveAsName;
      }
    }

    // Works same for Admin and User roles

    if (this.saveAsSelected) {
      let ico = 'ico-user-16';
      let flag = 5;
      this.templateType = 'Private';
      this.templateTypeList = this.templateTypeListPrivate;
      // Save when in admin mode
      if (this.admin) {
        flag = 3;
        ico = 'ico-group-16';
        this.templateType = 'Common';
        this.templateTypeList = this.templateTypeListCommon;
      }

      const newTemplate: VirtualGridTemplate = {
        isGlobalTemplate: this.admin, // take from user selection
        template: this.selectedTemplate.template,
        templateId: 0,
        templateName: this.saveAsName,
        flags: flag,
        icon: ico
      };
      this.selectedTemplate = newTemplate;

      // Update the selected Template name
      this.selectedTemplate.templateName = this.saveAsName;
      this.worklistMetaSave.emit({ vgc: this.shownWorklistColumnData, vgt: newTemplate }); //vgt: this.selectedTemplate
      this.isLayoutChanged = false;
    } else {
      // Simple Save on adding Removing Columns
      // User Cannot save Global ( the Save is disabled so cannot get here for Global Templates)
      // Save Global Template As User Template
      if (this.selectedTemplate.isGlobalTemplate && (this.isTemplateGlobalPrivate || this.templateType === 'Private')) {
        this.saveGlobalPrivateTemplate();
      } else {
        this.worklistMetaSave.emit({ vgc: this.shownWorklistColumnData, vgt: this.selectedTemplate });
      }

      this.isLayoutChanged = false;
    }

    this.updateTemplateLists();
  }

  private saveGlobalPrivateTemplate() {
    // New usersCopyOfGlobal Scenario
    let templateIdIfExisting = 0;
    let templateNameIfExisting = this.selectedTemplate.templateName + '_u$er';
    // Update Scenario
    const autoSavedGlobal = this.templatesHashMap.get(templateNameIfExisting);
    let globalPrivateTemplateForSave: VirtualGridTemplate;
    if (autoSavedGlobal) {
      templateIdIfExisting = autoSavedGlobal.templateId;
      templateNameIfExisting = autoSavedGlobal.templateName;
      globalPrivateTemplateForSave = {
        isGlobalTemplate: false, // take from user selection
        template: this.selectedTemplate.template,
        templateId: templateIdIfExisting,
        templateName: templateNameIfExisting,
        flags: 7,
        icon: ''
      };
    } else {
      globalPrivateTemplateForSave = {
        isGlobalTemplate: false, // take from user selection
        template: this.selectedTemplate.template,
        templateId: 0,
        templateName: templateNameIfExisting,
        flags: 7,
        icon: ''
      };
    }
    // Need to send an event for saving the hidden usesr global private worklist
    this.worklistMetaSave.emit({ vgc: this.shownWorklistColumnData, vgt: globalPrivateTemplateForSave });
  }

  layoutCountMessage = '';
  /* SaveAs  and Related Actions"*/
  saveAs(): void {
    /* Triggers boolean */

    if (!this.admin && this.currentUserLayoutsCount + 1 > this.maxUserLayouts) {
      this.layoutCountMessage = this.translate
        .instant('vgl.templates_maxUserLayoutsError')
        .replace('[maxUserLayouts]', this.maxUserLayouts);
      return;
    }
    if (this.admin && this.globalLayoutsCount + 1 > this.maxGlobalLayouts) {
      this.layoutCountMessage = this.translate
        .instant('vgl.templates_maxGlobalLayoutsError')
        .replace('[maxGlobalLayouts]', this.maxGlobalLayouts);
      return;
    }

    this.layoutCountMessage = '';
    this.saveAsSelected = true;
    this.showRename = false;
    //Disable Save As
    this.showSaveAs = false;
  }

  isDuplicate = false;

  /* After SaveAs  saveAsSave is Enabled"*/
  saveAsSave(): void {
    this.isNewLayoutSaved = true;
    this.isDuplicate = this.checkDuplicateTemplateName();
    if (this.isDuplicate) {
      return;
    } else {
      this.layoutCountMessage = '';
      this.saveColumns();
    }
    this.isDuplicate = false;
    this.renameSelected = false;
    this.saveAsSelected = false;
    this.showSaveAs = true;
  }

  /* After SaveAs  Cancel is Enabled"*/
  saveAsCancel(): void {
    this.renameSelected = false;
    this.saveAsSelected = false;
    this.layoutCountMessage = '';
    this.showSaveAs = false;

    this.checkActionButtonsConsistency();
  }

  checkDuplicateTemplateName() {
    this.isDuplicate = false;
    if (!this.saveAsName) {
      this.layoutCountMessage = this.translate.instant('vgl.templates_emptyNameError');
      this.isDuplicate = true;
      return this.isDuplicate;
    }

    this.saveAsName = this.saveAsName.trim();

    if (this.saveAsName) {
      const myRegxp = /^[a-zA-Z0-9]{1,30}$/;
      if (myRegxp.test(this.saveAsName) == false) {
        this.layoutCountMessage = this.translate.instant('vgl.templates_newNameMinLengthError');
        this.isDuplicate = true;
        return this.isDuplicate;
      }
    }

    if (this.templatesHashMap.has(this.saveAsName)) {
      this.isDuplicate = true;
      this.layoutCountMessage = this.translate.instant('vgl.templates_duplicateNameError');
      return this.isDuplicate;
    }
    this.layoutCountMessage = '';
    return this.isDuplicate;
  }

  private updateTemplateLists() {
    this.currentUserLayoutsCount = 0;
    this.globalLayoutsCount = 0;

    //empty to remove any old items
    this.alltemplates = [];
    this.commontemplates = [];

    this.templates.forEach(template => {
      //have all including SystemAutoSaves for User with 'globaltemplateName_u$er'
      this.templatesHashMap.set(template.templateName, template);
      if (template.isGlobalTemplate && template.flags === 3) {
        template.icon = 'ico-group-16';
        this.commontemplates.push(template);
        this.alltemplates.push(template); //add Global
        this.globalLayoutsCount += 1;
      } else {
        // exclude  SystemAutoSaves
        if (template.flags === 5) {
          template.icon = 'ico-user-16';
          this.alltemplates.push(template); // add User
          this.currentUserLayoutsCount += 1;
        }
      }
    });

    if (this.admin) {
      this.templates = this.commontemplates;
      this.templateTypeList = this.templateTypeListCommon;
    } else {
      //Common and User
      this.templates = this.alltemplates;
    }
  }

  rename(): void {
    this.renameSelected = true;
    //sets the existing name for rename and disable save
    this.saveAsName = this.selectedTemplate.templateName;
    this.checkDuplicateTemplateName();
  }

  reset(): void {
    // Load/render template of System Default
    // Save Columns as GlobalTemplate
    this.renderTemplate(this.selectedTemplate);
    this.saveColumns();
  }

  delete(): void {
    //todo
  }

  removeFilter(): void {
    this.searchStr = '';
  }

  selectAndRenderRightTemplate() {
    this.isTemplateGlobalPrivate = false;
    this.showReset = false;
    const autoSavedGlobal = this.templatesHashMap.get(this.selectedTemplate.templateName + '_u$er');
    // Needs to happen before the restrictive check below for auto saved Global layout
    if (!this.admin) {
      if (this.selectedTemplate.isGlobalTemplate) {
        this.templateType = 'Common';
        this.templateTypeList = this.templateTypeListAll;
      } else {
        this.templateType = 'Private';
        this.templateTypeList = this.templateTypeListPrivate;
      }
    } else {
      this.templateType = 'Common';
    }

    if (
      !this.admin &&
      this.templateType === 'Common' &&
      this.selectedTemplate.isGlobalTemplate &&
      autoSavedGlobal &&
      autoSavedGlobal.flags === 7
    ) {
      this.templateType = 'Private';
      this.renderTemplate(autoSavedGlobal);
      this.autoSavedGlobalTemplate = autoSavedGlobal;
      this.isTemplateGlobalPrivate = true;
      this.showReset = true;
    } else {
      this.renderTemplate(this.selectedTemplate);
    }
  }

  templateSelectionChange(): void {
    this.isNewLayoutSaved = false;
    this.renameSelected = false;
    this.saveAsSelected = false;
    this.selectedGlobalHasPrivate = false;

    this.systemTemplateSelected = this.selectedTemplate.isGlobalTemplate;
    this.selectedTemplateChange.emit(this.selectedTemplate);

    //Reset Error Message
    this.layoutCountMessage = '';
    this.layoutErrorMessage = '';

    this.selectAndRenderRightTemplate();
  }

  // Only relevant if not admin and Global template
  templateTypeChange(item) {
    if (!this.admin && this.selectedTemplate.isGlobalTemplate) {
      if (item.value === 'Common') {
        this.renderTemplate(this.selectedTemplate);
        this.showReset = false;
      } else if (item.value === 'Private') {
        const autoSavedGlobal = this.templatesHashMap.get(this.selectedTemplate.templateName + '_u$er');
        if (autoSavedGlobal && autoSavedGlobal.flags === 7) {
          this.showReset = true;
          this.sendLogToHost({ Action: 'Render Auto Saved User Template', Data: autoSavedGlobal });
          this.renderTemplate(autoSavedGlobal);
        } else {
          this.sendLogToHost({ Action: 'No User Copy of Global Template' });
        }
      }
    }
  }

  // Management Worklists Tab . Apply a Template to 1 or more worklists

  applyTemplatetoWorklist(): void {
    let all: Array<VirtualGridColumn> = [];
    all = all.concat(this.shownWorklistColumnData);
    all = all.concat(this.hiddenWorklistColumnData);
    this.applyWithoutSaveAndClose.emit(all);
  }

  sendLogToHost(logObj: any, logType?: string) {
    if (logObj) {
      logObj.ComponentName = '[Virtual-Grid-Layout]';
      if (logType === 'info1') {
        console.log(logObj); // change to info to log to console
      }
    }
  }

  //  --------------- Outbound Events --------------------

  renderTemplate(selectedTemplate: VirtualGridTemplate) {
    this.hiddenWorklistColumnData = [];
    this.shownWorklistColumnData = [];
    let temp;
    try {
      temp = JSON.parse(selectedTemplate.template).allColumnsAttributes;
    } catch (e) {
      this.sendLogToHost({ Exception: e, template: selectedTemplate }, 'error');
    }

    this.checkActionButtonsConsistency();

    if (temp) {
      const mod = [];
      // Add Shown in order
      temp.forEach(shownprop => {
        const shown = this.tempWorklistColumnMetaData.find(item => {
          return item.propertyIdentifier === shownprop;
        });
        if (shown) {
          shown.isHidden = false;
          mod.push(shown);
          this.shownWorklistColumnData.push(shown);
        }
      });

      // Add Hidden in order
      for (let i = 0; i < this.tempWorklistColumnMetaData.length; i++) {
        if (temp.indexOf(this.tempWorklistColumnMetaData[i].propertyIdentifier) < 0) {
          this.tempWorklistColumnMetaData[i].isHidden = true;
          mod.push(this.tempWorklistColumnMetaData[i]);
          this.hiddenWorklistColumnData.push(this.tempWorklistColumnMetaData[i]);
        }
      }

      this.tempWorklistColumnMetaData = mod;

      this.sendLogToHost({ templateAttributes: this.tempWorklistColumnMetaData }, 'info');
    }
    this.sortHidden();
  }

  showSaveAs = true;
  showRename = false;
  showReset = false;

  // For selected Temlate after a user action/template select
  checkActionButtonsConsistency() {
    this.isCommonTemplate = this.selectedTemplate.isGlobalTemplate ? true : false;

    this.layoutErrorMessage = '';

    this.showSaveAs = true;
    //reset
    this.isLayoutChanged = false;

    if (this.isCommonTemplate && !this.admin) {
      // hide save
      //show save as
      this.showRename = false;
    }

    if (this.isCommonTemplate && this.admin) {
      this.showRename = false; // cannot show for admin as the user layouts are based on layoutname and flag
      //changing this will have to rename for all users .
    }

    if (!this.isCommonTemplate && !this.admin) {
      // hide save until layout has changed
      this.showRename = true;
      //show save as
    }
  }

  checkUncheckAll() {
    this.selectedWorklists = 0;
    for (let i = 0; i < this.managementWorklists.length; i++) {
      this.selectedWorklists = this.selectedWorklists + 1;
      this.managementWorklists[i].isSelected = this.masterSelected;
    }
    this.anySelected = this.masterSelected;
  }

  // Not Implemented in UI
  checkUncheckSystem() {
    for (let i = 0; i < this.managementWorklists.length; i++) {
      if (this.managementWorklists[i].worklistType == 'System') {
        this.managementWorklists[i].isSelected = this.systemSelected;
      }
    }
    this.isAllSelected();
    this.isAnySelected();
  }

  checkUncheckCustom() {
    for (let i = 0; i < this.managementWorklists.length; i++) {
      if (this.managementWorklists[i].worklistType == 'Custom') {
        this.managementWorklists[i].isSelected = this.customSelected;
      }
    }
    this.isAllSelected();
    this.isAnySelected();
  }
  // Not Implemented

  isAllSelected() {
    this.masterSelected = this.managementWorklists.every(function (wl: VirtualGridWorklist) {
      return wl.isSelected == true;
    });
  }

  selectedWorklists = 0;
  isAnySelected() {
    let tempAny = false;
    this.selectedWorklists = 0;
    for (let i = 0; i < this.managementWorklists.length; i++) {
      if (this.managementWorklists[i].isSelected) {
        tempAny = true;
        this.selectedWorklists = this.selectedWorklists + 1;
      }
    }

    this.anySelected = tempAny;
  }

  applyTemplate() {
    const selectedTemplates = [];
    for (let i = 0; i < this.managementWorklists.length; i++) {
      if (this.managementWorklists[i].isSelected) {
        selectedTemplates.push(this.managementWorklists[i].worklistId);
        if (this.applyToSystem) {
          this.managementWorklists[i].defaultTemplate = [
            this.selectedTemplate.templateId,
            this.selectedTemplate.templateName
          ];
        } else {
          this.managementWorklists[i].currentTemplate = [
            this.selectedTemplate.templateId,
            this.selectedTemplate.templateName
          ];
        }
      }
    }

    if (this.admin) {
      //saves Common Layouts
      this.applyDefaultTemplateToWorklistsEvent.emit(selectedTemplates);
    } else {
      this.applyTemplateToWorklistsEvent.emit(selectedTemplates);
    }

    // Reset Selection after successfull apply
    for (let i = 0; i < this.managementWorklists.length; i++) {
      if (this.managementWorklists[i].isSelected) {
        this.managementWorklists[i].isSelected = false;
      }
    }
    this.anySelected = false;
    this.sendLogToHost(
      {
        Action: 'Management Worklists Templates Change Applied',
        WorklistsUpdated: selectedTemplates,
        TemplateApplied: this.selectedTemplate
      },
      'info'
    );
  }

  position(event: string, position: number) {
    this.sendLogToHost({ Action: 'PostionChanged', EventName: event, Position: position }, 'info');
  }

  accordionSelectionChange(event: string) {
    return event;
  }

  accordionItemSelectionChange(event: string) {
    return event;
  }

  activeTabIndexChange() {
    this.activeTab = this.tabSelected ? 'management' : 'templates';
    this.activeTabChange.emit(this.activeTab);
  }
}
